export default __webpack_public_path__ + "static/media/icon-mitigation-white.d0fd483b.svg";